import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import { MultiLearnerForm } from './MultiLearnerForm';
import { useState } from 'react';

interface MultiLearnerFormData {
  formationId: string;
  startDate: Date;
  learners: Array<{
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    position?: string;
  }>;
}

interface AddLearnerModalProps {
  learnerCount: number;
  preselectedFormationId?: string;
  preselectedFormationTitle?: string;
  savedLearners?: Array<{
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    position?: string;
  }>;
  onLearnersAdded?: (data: MultiLearnerFormData) => void;
}

export function AddLearnerModal({ 
  learnerCount, 
  preselectedFormationId, 
  preselectedFormationTitle,
  savedLearners = [],
  onLearnersAdded 
}: AddLearnerModalProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmit = async (data: MultiLearnerFormData) => {
    // Ici, vous ajouterez l'intégration avec Airtable ou votre API
    console.log('Nouveaux apprenants:', data);
    
    // Simuler l'ajout
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Fermer le modal et notifier le parent
    setIsOpen(false);
    onLearnersAdded?.(data);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button className="btn-primary">
          <UserPlus className="mr-2 h-4 w-4" />
          Ajouter {learnerCount} apprenant{learnerCount > 1 ? 's' : ''}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <MultiLearnerForm 
          learnerCount={learnerCount}
          preselectedFormationId={preselectedFormationId}
          preselectedFormationTitle={preselectedFormationTitle}
          savedLearners={savedLearners}
          onSubmit={handleSubmit} 
          onCancel={handleCancel} 
        />
      </DialogContent>
    </Dialog>
  );
}